import { useState } from "react";
import { IDbBaseMetadataValueInfos } from "../../Core/Api/Types/i-db-base-metadata-value-infos";

export default function useMetadataForm() {
  const [metadataListFilled, setMetadataListFilled] = useState<IDbBaseMetadataValueInfos[]>([]);
  const [formValid, setFormValid] = useState<boolean>(false);

  const handleMetadataChanges = (isValid: boolean, metadata: IDbBaseMetadataValueInfos[]) => {
    setFormValid(isValid);
    setMetadataListFilled(metadata);
    console.debug("modal::ME change valid = [" + isValid + "] for field count = [" + metadata.length + "]");
  };

  return {
    metadataListFilled,
    formValid,
    handleMetadataChanges,
    setMetadataListFilled,
  };
}
